import PropTypes from "prop-types"
import styled from 'styled-components';
import React from 'react';
import LOADERIMG from './assets/counter.gif';

const Container_div = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  height: 100vh;
  width: 100vw;
  color: #efefef !important;
  background-color: #0a0908aa !important;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 1.5rem;
  z-index: 99999;
  font-family: 'Mulish';
  backdrop-filter: blur(6px);
  opacity: 1 !important;
`;

const Spinner_svg = styled.svg`
  display: block;
  height: 3rem;
  width: 3rem;
  fill: #efefef !important;
`;

export default function LoadingIndicator({ text, style, ariaLabel }) {
  const neutralizeFilter = React.useMemo(() => {
    if (typeof document === 'undefined') return undefined;

    const classNames = [
      document.documentElement?.className,
      document.body?.className,
    ]
      .filter(Boolean)
      .join(' ');

    if (!classNames) return undefined;

    const parts = [];

    if (classNames.includes('accessibility-invert-color')) {
      parts.push('invert(1) hue-rotate(180deg)');
    }

    if (classNames.includes('accessibility-high-saturation')) {
      parts.push('saturate(0.5)');
    }

    if (classNames.includes('accessibility-low-saturation')) {
      parts.push('saturate(2)');
    }

    if (classNames.includes('accessibility-grayscale')) {
      parts.push('grayscale(0)');
    }

    if (parts.length === 0) return undefined;
    return parts.join(' ');
  }, []);

  const mergedStyle = React.useMemo(() => {
    const next = { ...(style || {}) };

    if (neutralizeFilter) {
      next.filter = neutralizeFilter;
      next.WebkitFilter = neutralizeFilter;
    }

    return next;
  }, [style, neutralizeFilter]);

  return (
    <Container_div 
      style={mergedStyle}
      role="alert"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel || text || 'Please wait while we are fetching details...'}
    >
      <img src={LOADERIMG} alt="loading" style={{width: '130px', height: '130px'}} />
      {/* <Spinner_svg
        width="135"
        height="135"
        viewBox="0 0 135 135"
        xmlns="http://www.w3.org/2000/svg"
        fill="#efefef"
        aria-hidden="true"
        focusable="false">
        <path d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 67 67"
            to="360 67 67"
            dur="2s"
            repeatCount="indefinite"
          />
        </path>
      </Spinner_svg> */}
      <div>{text || 'Please wait while we are fetching details...'}</div>
    </Container_div>
  );
}

LoadingIndicator.propTypes = {
  style: PropTypes.any,
  text: PropTypes.string,
  ariaLabel: PropTypes.string
}
